<template>
  <div class="addressContainer">
    <div class="jusoItemContainer">
      <div class="jusoItem" style="width:577px">
        <div class="jusoInfoTitle">지번</div>
        <div class="jusoInfoDesc">{{ this.kakaoAddressInfo.addressBjd || '-' }}</div>
      </div>
      <div class="jusoItem" style="width:300px;margin-left:20px;">
        <div class="jusoInfoTitle">위도</div>
        <div class="jusoInfoDesc">{{ this.kakaoAddressInfo.latY }}</div>
      </div>
    </div>
    <div class="jusoItemContainer" style="margin-top:12px;">
      <div class="jusoItem" style="width:577px">
        <div class="jusoInfoTitle">도로명</div>
        <div class="jusoInfoDesc">{{ this.kakaoAddressInfo.addressRoad || '-' }}</div>
      </div>
      <div class="jusoItem" style="width:300px;margin-left:20px;">
        <div class="jusoInfoTitle">경도</div>
        <div class="jusoInfoDesc">{{ this.kakaoAddressInfo.lonX }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "AddressInfoComponent",
  computed: {
    ...mapState(["kakaoAddressInfo"])
  }

}
</script>

<style scoped>
.jusoInfoTitle {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #A5A5A5;
  width: 80px;
  padding-left: 20px;
}

.jusoInfoDesc {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #424242;
  padding-left: 12px;
}

.addressContainer {
  width: 937px;
  height: 138px;
  background: #FAFAFA;
  border-radius: 8px;
  margin: 20px 0 36px;
  padding: 12px ;
}

.jusoItemContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 49px;
  padding: 16px 20px;
}

.jusoItem {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 17px 0;
  border-bottom: 1px solid #D2D2D2;
}
</style>
